import type { Availability, AvailabilityInputs, AvailabilityRule } from './availability'

/** A definite answer wins over an unresolved sibling, so a route never waits on a flag that cannot change it. */
export const resolveAvailability = (rule: AvailabilityRule, inputs: AvailabilityInputs): Availability => {
  switch (rule.kind) {
    case 'always':
      return 'available'
    // TODO(PLT-1723): merge these two arms. The readiness check is the only difference, so a merged
    // arm needs the source's readiness rather than `isLdReady`; the flag-name union that used to
    // block this now exists.
    case 'orgFlag':
      // Organisation settings resolve with the session, so this value is never provisional.
      return inputs.orgFlags[rule.name] === true ? 'available' : 'unavailable'
    case 'ldFlag':
      if (inputs.isLdReady === false) return 'pending'
      return inputs.ldFlags[rule.name] === true ? 'available' : 'unavailable'
    case 'omneanOnly':
      // Derived from the session's email, so this value is never provisional.
      return inputs.isOmnean ? 'available' : 'unavailable'
    case 'any': {
      const answers = rule.rules.map((child) => resolveAvailability(child, inputs))
      if (answers.includes('available')) return 'available'
      return answers.includes('pending') ? 'pending' : 'unavailable'
    }
    case 'all': {
      const answers = rule.rules.map((child) => resolveAvailability(child, inputs))
      if (answers.includes('unavailable')) return 'unavailable'
      return answers.includes('pending') ? 'pending' : 'available'
    }
  }
}
